import { render, staticRenderFns } from "./SocialAuth.vue?vue&type=template&id=fc4778cc&scoped=true&"
import script from "./SocialAuth.vue?vue&type=script&lang=js&"
export * from "./SocialAuth.vue?vue&type=script&lang=js&"
import style0 from "./SocialAuth.vue?vue&type=style&index=0&id=fc4778cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4778cc",
  null
  
)

export default component.exports